<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <!-- <v-col cols="12">
                                <v-btn class="mr-2" @click="handleContractStatuses">
                                    {{ $t('buttons.handleContractStatuses') }}
                                </v-btn>
                            </v-col> -->
                            <v-col>
                                <TheTable
                                    :additional-filters="itemsTable.additionalFilters"
                                    :default-sort="itemsTable.defaultSort"
                                    :excel="true"
                                    :fields="itemsTable.headers"
                                    :header-selection-key="'contracts-all-headers'"
                                    :height="itemsTable.height"
                                    :total-records="itemsTable.total"
                                    :filter-save-key="'all-contracts-filters'"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="item in itemsTable.items"
                                        :key="item.id"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(item, true)"
                                    >
                                        <td
                                            v-if="itemsTable.selectedHeaders.includes('id')"
                                            class="font-weight-bold"
                                            @click="editClick(item, false)"
                                        >
                                            {{ item.id }}
                                        </td>
                                        <td
                                            v-if="itemsTable.selectedHeaders.includes('status')"
                                            @click="editClick(item, false)"
                                        >
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-chip
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="text-uppercase pl-4"
                                                        :text-color="statusColor(item.contract_status_id).text"
                                                        :color="statusColor(item.contract_status_id).background"
                                                        >{{ item.status_display }}</v-chip
                                                    >
                                                </template>
                                                <span> {{ $t('tooltips.openSeafarerActivity') }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="itemsTable.selectedHeaders.includes('effective_from')"
                                            @click="editClick(item, false)"
                                        >
                                            {{ item.effective_from_display }}
                                        </td>
                                        <td
                                            v-if="itemsTable.selectedHeaders.includes('effective_to')"
                                            @click="editClick(item, false)"
                                        >
                                            {{ item.effective_to_display }}
                                        </td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="itemsTable.selectedHeaders.includes('seafarer')"
                                            @click="editClick(item, false)"
                                        >
                                            {{ item.seafarer_display }}
                                        </td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="itemsTable.selectedHeaders.includes('vessel')"
                                            @click="editClick(item, false)"
                                        >
                                            {{ item.vessel_display }}
                                        </td>
                                        <td
                                            v-if="itemsTable.selectedHeaders.includes('rank')"
                                            @click="editClick(item, false)"
                                        >
                                            {{ item.rank_display }}
                                        </td>
                                        <td
                                            v-if="itemsTable.selectedHeaders.includes('entity')"
                                            @click="editClick(item, false)"
                                        >
                                            {{ item.entity_display }}
                                        </td>
                                        <td
                                            v-if="itemsTable.selectedHeaders.includes('placement_id')"
                                            @click="editClick(item, false)"
                                        >
                                            {{ item.placement_id }}
                                        </td>

                                        <td
                                            v-if="itemsTable.selectedHeaders.includes('date_created')"
                                            @click="editClick(item, false)"
                                        >
                                            {{ item.created_at_display }}
                                        </td>
                                        <td
                                            v-if="itemsTable.selectedHeaders.includes('issued_by')"
                                            @click="editClick(item, false)"
                                        >
                                            {{ item.user_display }}
                                        </td>
                                        <td class="text-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn icon v-bind="attrs" @click="editClick(item, true)" v-on="on">
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'Entities',
    components: {TheTable},
    data: function () {
        return {
            itemsTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.contractId'), value: 'id', type: '', allowFilter: false},
                    {
                        text: this.$t('fields.status'),
                        value: 'status',
                        type: '',
                        allowFilter: false,
                    },
                    {
                        text: this.$t('fields.effectiveFrom'),
                        value: 'effective_from',
                        type: '',
                        allowFilter: false,
                    },
                    {
                        text: this.$t('fields.effectiveTo'),
                        value: 'effective_to',
                        type: '',
                        allowFilter: false,
                    },
                    {
                        text: this.$t('fields.seafarer'),
                        value: 'seafarer',
                        type: '',
                        allowFilter: false,
                    },
                    {text: this.$t('fields.vessel'), value: 'vessel', type: '', allowFilter: false},
                    {
                        text: this.$t('fields.rank'),
                        value: 'rank',
                        type: '',
                        allowFilter: false,
                    },
                    {
                        text: this.$t('fields.entity'),
                        value: 'entity',
                        type: '',
                        allowFilter: false,
                    },
                    {
                        text: this.$t('fields.placementId'),
                        value: 'placement_id',
                        type: '',
                        allowFilter: false,
                    },

                    {
                        text: this.$t('fields.dateCreated'),
                        value: 'date_created',
                        type: '',
                        allowFilter: false,
                    },
                    {
                        text: this.$t('fields.issuedBy'),
                        value: 'issued_by',
                        type: '',
                        allowFilter: false,
                    },
                ],
                additionalFilters: [
                    {text: this.$t('fields.effectiveFrom'), value: 'effective_from', type: 'date_range'},
                    {text: this.$t('fields.effectiveTo'), value: 'effective_to', type: 'date_range'},
                    {text: this.$t('fields.dateCreated'), value: 'date_created', type: 'date_range'},
                ],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'id',
                    descending: true,
                },
                componentKey: 1,
            },
        };
    },
    methods: {
        statusColor(statusId) {
            const colors = {
                1: {text: '#008000', background: '#00800040'},
                2: {text: '#BBBB00', background: '#E1E10040'},
                3: {text: '#6F6F6F', background: '#6F6F6F40'},
                4: {text: '#FF0000', background: '#FF000040'},
                5: {text: '#4360DF', background: '#4360DF40'},
            };
            return colors[statusId] || colors[3];
        },
        handleContractStatuses() {
            let vm = this;
            this.$APICall('post', 'handle-contract-statuses', {}, (data, success) => {
                if (success) {
                    vm.componentKey += 1;
                }
            });
        },
        addClick() {
            this.$router.push('/items/0');
        },
        editClick(item, newTab = false) {
            if (!newTab) {
                this.$router.push('/placements/' + item.placement_id);
            } else {
                let routeData = this.$router.resolve('/placements/' + item.placement_id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.itemsTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'contracts', request, (data, success) => {
                if (success) {
                    vm.itemsTable.items = data.items;
                    vm.itemsTable.total = data.total;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'contracts',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/contracts', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.itemsTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped></style>
